import { useState, useEffect } from 'react'

export const useTooltip = (props: { text: string }): { text: string } => {
  const [text, setText] = useState(props.text || null)

  useEffect(() => {
    return () => {
      setText(null)
    }
  }, [])

  useEffect(() => {
    setText(props.text || null)
  }, [props.text])

  return {
    text
  }
}
